import React from 'react';
import {
  Container,
  Box,
  Typography,
  Button,
  Paper,
} from '@mui/material';
import {
  LocalOffer,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import Herosection from '../components/Herosection';
import CategorySection from '../components/CategorySection';
import TrendingDeals from '../components/TrendingDeals';
import DealsNearYou from '../components/DealsNearYou';
import FeaturedDeals from '../components/FeaturedDeals'; // ✅ New Import
import AboveFooter from '../components/AboveFooter'; // ✅ New Import

const Homepage = () => {
  const navigate = useNavigate();

  return (
    <Box>
      {/* Hero Section */}
      <Herosection />

      {/* Categories Section */}
      <CategorySection />

      {/* Trending Deals Section */}
      <TrendingDeals />

      {/* Deals Near You Section */}
      <DealsNearYou />

      {/* Featured Deals Section */}
      {/* <FeaturedDeals /> */}

      <AboveFooter/>
    </Box>
  );
};

export default Homepage;
